import React from "react";

import accretionColor from "../../../../../../../.claude/design-system/assets/logos/partners/accretion-horizontal.png";
import zenithColor from "../../../../../../../.claude/design-system/assets/logos/partners/zenith.svg";
import type { AuditLogoKey } from "../securityEvidence";

interface AuditLogoProps {
    logo: AuditLogoKey;
    alt: string;
    className?: string;
}

/** Show each auditor's original-color asset from the synced design system. */
export function AuditLogo({
    logo,
    alt,
    className
}: AuditLogoProps): React.ReactElement {
    return (
        <img
            src={logo === "logo/zenith" ? zenithColor : accretionColor}
            alt={alt}
            className={className}
        />
    );
}
